import { type JSX } from 'react';

export function VideoEditSelectionMetadataError({ message }: { message: string }): JSX.Element {
    return (
        <div
            role="alert"
            className="flex items-center justify-center w-full h-10 rounded-b-md bg-neutral-dark-200 text-xs text-neutral-dark-900"
        >
            {message}
        </div>
    );
}
